import { ButtonTheme } from '@/components/Button/theme';

const Button = ButtonTheme;

export default Object.assign({}, { Button });
